import { render, staticRenderFns } from "./IcelandicTerm.vue?vue&type=template&id=f1b2de08&scoped=true&"
import script from "./IcelandicTerm.vue?vue&type=script&lang=js&"
export * from "./IcelandicTerm.vue?vue&type=script&lang=js&"
import style0 from "./IcelandicTerm.vue?vue&type=style&index=0&id=f1b2de08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b2de08",
  null
  
)

export default component.exports